// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1ulg5","productName":"Table_productName__1jrGa"};